const galleryImages = [
  "gallery (1).jpg",
  "gallery (2).jpg",
  "gallery (3).jpg",
  "gallery (4).jpg",
  "gallery (5).jpg",
  "gallery (6).jpg",
  "gallery (7).jpg",
  "gallery (8).jpg",
  "gallery (9).jpg",
  "gallery (10).jpg",
  "gallery (11).jpg",
  "gallery (12).jpg",
  "gallery (13).jpg",
  "gallery (14).jpg",
  "gallery (15).jpg",
  "gallery (16).jpg",
  "gallery (17).jpg",
  "gallery (18).jpg",
  "gallery (19).jpg",
  "gallery (20).jpg",
  "gallery (21).jpg",
  "gallery (22).jpg",
  "gallery (23).jpg",
  "gallery (24).jpg",
  "gallery (25).jpg",
  "gallery (26).jpg",
  "gallery (27).jpg",
  "gallery (28).jpg",
  "gallery (29).jpg",
  "gallery (30).jpg",
  "gallery (31).jpg",
  "gallery (32).jpg",
  "gallery (33).jpg",
  "gallery (34).jpg",
  "gallery (35).jpg",
  "gallery (36).jpg",
  "gallery (37).jpg",
  "gallery (38).jpg",
  "gallery (39).jpg",
  "gallery (40).jpg",
  "gallery (41).jpg",
  "gallery (42).jpg",
  "gallery (43).jpg",
  // add as many as you want
];

export default galleryImages;
